
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { MarkdownModule } from 'ngx-markdown';

@Component({
  selector: 'app-disclaimer-modal',
  templateUrl: './disclaimer-modal.component.html',
  styleUrls: ['./disclaimer-modal.component.scss'],
  imports: [
    FormsModule,
    MarkdownModule
]
})
export class DisclaimerModalComponent {
  public dontShowAgain: boolean = false;
  public text: string = '';

  constructor(public bsModalRef: BsModalRef) { }

}
